import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'
import moment from 'moment'


import { dirtyRead, doc } from 'selectors/common'

const icons = {
	'Application ': <img src={"/manager/static/img/property_statuses/app.png"} width="65%" style={{position:"relative", left:"5px", top:"4px"}} alt="Application"/>
  , 'Application accepted': <img src={"/manager/static/img/property_statuses/appAcc.png"} width="65%" style={{position:"relative", left:"5px", top:"4px"}} alt="Application"/>
  , 'Application rejected': <img src={"/manager/static/img/property_statuses/appRej.png"} width="65%" style={{position:"relative", left:"5px", top:"4px"}} alt="Application"/>
  , 'Contract': <img src={"/manager/static/img/property_statuses/contract.png"} width="85%" style={{position:"relative", left:"1px", top:"-1px"}} alt="Contract"/>
  , 'Contract renewal': <img src={"/manager/static/img/property_statuses/contract.png"} width="85%" style={{position:"relative", left:"1px", top:"-1px"}} alt="Contract"/>
  , 'Contract break': <img src={"/manager/static/img/property_statuses/contract-break.png"} width="85%" style={{position:"relative", left:"1px", top:"0px"}} alt="Contract break"/>
  , 'Move in': <img src={"/manager/static/img/property_statuses/move-in.png"} width="100%" style={{position:"relative", left:"-2px"}} alt="Move in"/>
  , 'Move out': <img src={"/manager/static/img/property_statuses/move-out.png"} width="100%" style={{position:"relative", left:"1px"}} alt="Move out"/>
  , 'Listing': <img src={"/manager/static/img/property_statuses/listed.png"} width="75%" style={{position:"relative", left:"3px", top:"4px"}} alt="Listing"/>
  , 'Task': <img src={"/manager/static/img/property_statuses/pic-repair.png"} width="60%" style={{position:"relative", left:"5px", top: "1px"}} alt="Task"/>
  , 'No payment': <img src={"/manager/static/img/property_statuses/picunpaid.png"} height="100%" style={{position:"relative", left:"4px"}} alt="no payment"/>
  , 'Partial payment': <img src={"/manager/static/img/property_statuses/picunpaid.png"} height="100%" style={{position:"relative", left:"4px"}} alt="no payment"/>
  , 'Late payment': <img src={"/manager/static/img/property_statuses/latepayment.png"} height="100%" style={{position:"relative", left:"4px"}} alt="payment"/>
  , 'Rent collected': <img src={"/manager/static/img/property_statuses/picpaid.png"} height="100%" style={{position:"relative", left:"4px"}} alt="no payment"/>
  , 'Bill paid': <img src={"/manager/static/img/property_statuses/picpaid.png"} width="100%" style={{position:"relative", left:"-2px"}} alt="payment"/>
  , 'Repair': <img src={"/manager/static/img/property_statuses/repair.png"} width="60%" style={{position:"relative", left: "4px", top: "1px"}} alt="repair"/>
  , 'Retired': <img src={"/manager/static/img/property_statuses/retired.png"} width="60%" style={{position:"relative", left: "4px", top: "1px"}} alt="repair"/>
  , 'Cleaning and maintenance': <img src={"/manager/static/img/property_statuses/cleaning.png"} width="60%" style={{position:"relative", left: "4px", top: "1px"}} alt="repair"/>
}
export default class EventCard extends Component {
	render(){
		return(
			this.props.event.type=="Divider"
			?<Divider style={{margin:"0px 0px 0px 0px", width: "100%"}}/>
			:<Link
				className="vandor-card"
				to={this.props.event.url}
				style={{
					textDecoration: 'none'
				  , color: "black"
				  , width: "100%"
				}}
			>
				<ListItem
					style={{
						overflow: 'hidden'
					  , paddingLeft: (typeof global.md.phone() == 'string')?"10px":"0"
					  , marginLeft: (typeof global.md.phone() != 'string')?"0":undefined
					  , margin: "0"
					  , textOverflow: "ellipsis"
					  , cursor: "default"
					  , width: "100%"
					}}
					innerDivStyle={{
						padding: "0 5px 0 15px"
					}}
					className="list-hover"
				>
				<table style={{
					width: "100%"
				  , color:(this.props.event.dateFormat && moment(new Date(this.props.event.dateFormat)).format('YYYY-MM-DD')>moment(new Date(this.props.currentDate)).format('YYYY-MM-DD')) || this.props.retired ? "rgb(200,200,200)" : "black"}}
				>
					<tbody>
						<tr>
						  <td
							style={{
								  width: '6%',
								  padding:'0',
								  height:"30px",
							  	  cursor:"pointer",
								  fontSize:"0",
								  overflowY:"hidden"
						   	}}
						  >
						  	<div style={{height:"30px", overflowY:"hidden"}}>
								  <div style={{ width: '20px', padding:'0', height:"100px", fontSize:"0", position:"absolute", top:"-10px", margin:"0"}}>
								  	<div
										style={{
											position:"absolute",
											top:this.props.event.type=="Rent collected"?"30px":"20px",
											left:this.props.event.type=="Rent collected"?"2px":"-8px",
											background:this.props.event.contractedEvent?"white":"none",
											zIndex:"100",
											width:this.props.event.type=="Rent collected"?"8px":"34px",
											height:this.props.event.type=="Rent collected"?"8px":"34px",
											padding:"4px",
											boxSizing:"border-box",
											border:this.props.event.contractedEvent?"3px solid #009688":"none",
											borderRadius: "50%",
											overflow:"hidden"
										}}
									>
										{icons[this.props.event.type] || icons[this.props.event.category]}
									</div>
									<svg  width="20.167882919311523" height="95" top="-20" transform="scale(0.8)">
									 <title>my vector image</title>
									 <g className="currentLayer">
										 <title>Layer 1</title>
										 {this.props.event.type!="Contract" && this.props.event.contractedEvent && <rect id="svg_4" height="50" width="3" y="25" x="7.29803" stroke-opacity="null" stroke="#009688" fill="#009688"/>}
										 {this.props.event.type!="Move out" && this.props.event.contractedEvent && <rect id="svg_3" height="70" width="3" y="-30" x="7.29803" stroke-opacity="null"stroke="#009688" fill="#009688"/>}
									 </g>
										<g>
										 <title>Layer 2</title>
										 <rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="#FFFFFF" opacity="0"/>
										</g>
										<g>
										 <title>background</title>
										</g>
										<g>
										 <title>background</title>
										 <rect fill="none" id="canvas_background" height="9.26027" width="4.87671" y="-1" x="-1"/>
										</g>
									</svg>
							      </div>
							  </div>
						  </td>
						  <td style={{
							  fontSize: "13px"
							, overflow: "hidden"
							, boxSizing: "border-box"
							, textAlign: "right"
							, padding: '6px 0px 4px 10px'
							, width:"80%"
							, overflowY:"hidden"
							, cursor:"pointer"
						}}>
							<div style={{height: "40px", overflowY:"hidden"}}>
								<div style={{float:"left", maxWidth: "80%", textAlign:"left", position:"relative", top:"2px"}}>
									{this.props.event.type!="Task" && this.props.event.type!="Late payment" && <p style={{height: "18px", margin:"0", fontWeight:"bold", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{this.props.event.type}</p>}
									{this.props.event.type=="Task" && <p style={{height: "18px", margin:"0", fontWeight:"bold", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{this.props.event.name}</p>}
									{this.props.event.type=="Late payment" && <p style={{height: "18px", margin:"0", fontWeight:"bold", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{this.props.event.name}</p>}
									<p style={{margin:"2px", fontSize:"11px", color:"#9e9e9e"}}>{this.props.event.date}</p>
								</div>
								<p
									style={{
										float:"right"
										, color:this.props.event.description=="Rejected"?"red":this.props.event.description=="Accepted"?"green":"black"
										, textOverflow: "ellipsis"
										, whiteSpace: "nowrap"
										, overflow: "hidden"
										, maxWidth:"250px"
										, margin:"0"
										, lineHeight:"40px"
										, fontWeight:"bold"
										, fontSize: "13px"
									}}
								>
									{this.props.event.description}
								</p>

							</div>
						</td>
						  </tr>
					</tbody>
				</table>
				</ListItem>
			</Link>
		)

	}

}



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/events/Card.js